import { Component, OnDestroy, OnInit } from '@angular/core';
import { RestService } from '../../../service/rest.service';
import { NavigationEnd, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import * as fromRoot from '../../../store/reducers';
import { Structure } from '../../../models/app.model';
import { distinctUntilChanged, filter, first, map, switchMap, tap } from 'rxjs/operators';
import { HelperSystem, urlPrefix } from '../../helpers/helper.system';
import { VpoName } from '../../../models/vpo.model';
import { getData } from '../../../store/reducers/structure';
import { getSelected } from '../../../store/reducers/vpo';


@Component({
  selector: 'app-site-breadcrumbs',
  templateUrl: './site-breadcrumbs.component.html',
  styleUrls: ['./site-breadcrumbs.component.scss']
})
export class SiteBreadcrumbsComponent implements OnInit, OnDestroy {

  breadcrumbs: Array<Structure> = [];
  selectedVpo: VpoName;
  selectedStructure: Structure;
  structures: Array<Structure> = [];
  private subscribers: Array<any> = [];
  defaultUrlPrefix: string;


  constructor(private restService: RestService,
              private route: Router,
              private store: Store<fromRoot.AppState>) {
    const url = urlPrefix(this.route.url);
    this.defaultUrlPrefix = url.replace(/\/[\d]+/ig, '');
  }

  ngOnInit() {

    // get selected vpo
    this.subscribers.push(this.store
      .pipe(
        select(fromRoot.selectVpoState())
      )
      .subscribe((state: any) => {
        this.selectedVpo = getSelected(state);
      }));

    const lastUrl$ = this.route.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        distinctUntilChanged(),
        map((event: NavigationEnd) =>  event.urlAfterRedirects) // get final url
      );

    const store$ = this.store
     .pipe(
       select(fromRoot.selectStructureState()),
       map((state: any) => getData(state)),
       map( s => (s ? s : null)), // get structures
       first( s => s.length !== 0),
       tap( s => {
          this.structures = s;
          // init default
          this.selectedStructure = this.structures.filter( _d => _d.path === this.defaultUrlPrefix)[0];
          if (this.selectedStructure) {
            this.buildBreadCrumb(this.selectedStructure, this.structures);
          }
       }),
       switchMap( s => lastUrl$),
       map(l => {
         const url = urlPrefix(l); // get url
         const url_prefix = url.replace(/\/[\d]+/ig, '');
         this.selectedStructure = this.structures.filter( _d => _d.path === url_prefix)[0];
         return this.selectedStructure;
       }),
     );

    this.subscribers.push(store$
      .subscribe( s => {
        this.breadcrumbs = [];
        if (s) {
          this.buildBreadCrumb(s, this.structures);
        }
      })
    );
  }

  /**
   * Build breadcrumbs tree from site structure
   *
   * @param s1
   * @param s2
   */
  buildBreadCrumb(s1: Structure, s2: Array<Structure> = []) {
    this.breadcrumbs = [];
    const findTree = (s: Array<Structure>, id: string) => {
        if (!id) {
          return;
        }
        const _t1 = s.find( (_s: Structure) => _s.id === id);
        if (_t1) {
          this.breadcrumbs.push(_t1);
          return findTree(s, _t1.idParent);
        } else {
          return;
        }
    };
    // build tree from structure
    this.breadcrumbs.push(s1); // first element
    findTree(s2, s1.idParent);
    // sort by parent key
    this.breadcrumbs =  this.breadcrumbs.sort(HelperSystem.sortDataByKey('idParent'));
  }

  ngOnDestroy() {
    this.subscribers.forEach(s => s.unsubscribe());
  }

}
